export default function DischargeCompanion() {
  return (
    <section id="discharge-companion" className="relative py-16 md:py-24 px-4 md:px-8 lg:px-12 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/9d08d37353a66055aeecef356618d098.png"
          alt="Family at hospital discharge pick-up"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 z-0 bg-black/50"></div>
      <div className="absolute top-0 left-0 right-0 h-1 gradient-brand-horizontal z-10"></div>
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="flex justify-center lg:justify-end order-2 lg:order-1">
            <div className="relative w-full max-w-[420px]">
              <div className="bg-white rounded-2xl p-6 md:p-8 border border-background-200/70 shadow-sm">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500">
                    <i className="ri-hospital-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-950">Hospital Discharge</h4>
                    <p className="text-xs text-foreground-600/50">Companion</p>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  {[
                    { icon: 'ri-medicine-bottle-line', label: 'Medication coordination' },
                    { icon: 'ri-car-line', label: 'Transport planning' },
                    { icon: 'ri-calendar-check-line', label: 'Follow-up appointments' },
                    { icon: 'ri-group-line', label: 'Family visit scheduling' },
                    { icon: 'ri-list-check-2', label: 'Recovery task checklist' },
                    { icon: 'ri-folder-2-line', label: 'Discharge document storage' },
                    { icon: 'ri-error-warning-line', label: 'Warning signs tracker' },
                    { icon: 'ri-alarm-warning-line', label: 'Emergency contacts' },
                  ].map((item, idx) => (
                    <div key={idx} className="flex items-center gap-2 bg-background-200/70 rounded-lg p-2.5">
                      <div className="w-7 h-7 flex items-center justify-center rounded-md bg-white flex-shrink-0">
                        <i className={`${item.icon} text-primary-500 text-xs`}></i>
                      </div>
                      <span className="text-xs text-foreground-700/80 leading-tight">{item.label}</span>
                    </div>
                  ))}
                </div>
                <div className="mt-5 pt-4 border-t border-background-200/70">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-xs text-foreground-600/60">Recovery Plan Progress</span>
                    <span className="text-xs font-semibold text-secondary-500">Day 4 of 30</span>
                  </div>
                  <div className="w-full h-2 bg-background-200/70 rounded-full overflow-hidden">
                    <div className="h-full bg-gradient-to-r from-secondary-500 to-secondary-400 rounded-full" style={{ width: '13%' }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="order-1 lg:order-2">
            <div className="inline-flex items-center gap-2 bg-secondary-500/10 rounded-full px-3 py-1.5 mb-5">
              <i className="ri-hospital-line text-secondary-500 text-xs"></i>
              <span className="text-xs font-semibold text-secondary-500 uppercase tracking-wider">New Feature</span>
            </div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-white mb-4 leading-tight">
              Hospital Discharge <span className="text-primary-500">Companion</span>
            </h2>
            <p className="text-base md:text-lg text-white/90 leading-relaxed mb-4">
              Coming home from hospital can be stressful. CareBridge helps families create a clear recovery plan.
            </p>
            <p className="text-sm text-white/80 leading-relaxed mb-6">
              Coordinate medication, transport, appointments, family visits, recovery tasks, discharge documents, warning signs, and emergency contacts in one simple app.
            </p>
            <p className="text-sm text-white/80 leading-relaxed mb-8">
              Whether your loved one is recovering from surgery, a fall, an illness, or a short hospital stay, CareBridge helps everyone know what needs to happen next.
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <a href="https://carebridge4elderly.base44.app" target="_blank" rel="nofollow noopener noreferrer" className="bg-primary-500 text-white font-semibold px-8 py-4 rounded-full hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap text-base inline-block">
                <span className="flex items-center gap-2">
                  Explore Discharge Companion
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}